import { Route, Routes } from "react-router-dom";

import { BusinessDetailsLink } from "../../pages";

export const BusinessDetailsLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<BusinessDetailsLink />} />
    </Routes>
  );
};
